<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="customer-cancel-modal-popup">
    <div class="modal-header">
      <h1 style="display:none;"></h1>
      <h2 id="customer-cancel-modal-container">{{cfetLabels.cfet_cancel_modal.heading}}</h2>
      <div class="corner-button">
        <button type="button" id="close-btn" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
          <em aria-label="Close" id="icon-close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </div>
    <div class="modal-body" id="confirmation-buttons-section" modal-content>
      <div id="modal-desc">
        <p id="description">{{cfetLabels.cfet_cancel_modal.description}}</p>
      </div>
      <div class="row" id="confirmation-buttons">
        <div class="col-md-6">
          <button type="button" id="btn-stay" (click)="close($event,'openModal')" (keyup)="close($event,'openModal')"
            class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.stayhere}}</button>
        </div>
        <div class="col-md-6">
          <button type="button" id="btn-cancel" (click)="cancelApplication($event,'openModal')"
            (keyup)="cancelApplication($event,'openModal')" class="btn btn-alt btn-medium" tabindex="0"><em
              aria-label=""></em>
            {{cfetButtonLabels.button_labels.cancelapplication}}</button>
        </div>
      </div>
    </div>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>